import { render, staticRenderFns } from "./HistoryMenu.vue?vue&type=template&id=c104a1f4&"
import script from "./historyMenu.js?vue&type=script&lang=js&"
export * from "./historyMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports